import HttpService from "@/services/HttpService";
import Apis from "@/services/Apis";
import { defaultSelectedStoreTag } from "@/views/StoreTag/inputs";
import { searchEntities } from "@/services/entityService";
import Entities from "@/resources/Entities";

const state = {
  storeTags: [],
  storeTag: { ...defaultSelectedStoreTag },
  loadingStatus: {
    saveStoreTag: false,
    getStoreTags: false,
    getStoreTagById: false,
    deleteStoreTag: false,
  },

  storeTagPopUp: {
    isOpen: false,},

  filterButtons:[
    {
      isSelected: false,
      _id: 10,
      label: "All",
      name: "all",
      showAll: false,
      filter: {
      },
    },{
      isSelected: true,
      _id: 11,
      label: "Available",
      name: "available",
      showAll: false,
      filter: {
        isUsed: false,
      },
    },
    {
      isSelected: false,
      _id: 12,
      label: "Used",
      name: "used",
      showAll: false,
      filter: {
        isUsed: true,
      },
    },
    {
      isSelected: false,
      _id: 13,
      label: "Archived",
      name: "archived",
      showAll: false,
      filter: {
        isArchived: true,
      },
    }
  ],
  selectedFilter: undefined,
  selectedPreFilters: undefined,
  sort: undefined,
  pagination: { skip: 0, limit: 20 },
  initialFilter: undefined
};

const mutations = {
  setLoadingStatus: (state, payload) => {
    if (payload) {
      state.loadingStatus[payload.api] = payload.status;
    }
  },
  setStoreTags: (state, payload) => {
    state.storeTags = payload;
  },

  setStoreTag: (state, payload) => {
    const defaultCopy = JSON.parse(JSON.stringify(defaultSelectedStoreTag));

    if (payload._id === "NEW") {
      searchEntities({
        filterCriteria: "isDefault",
        filterValue: "true",
        entity: Entities.STORETAG,
        skip: 0,
        limit: 1,
        positiveCallback: (data) => {
          state.storeTag = {
            ...defaultCopy,
            storeTag: data?.[0],
          };
        },
      });
    } else state.storeTag = { ...defaultCopy, ...payload };
  },

  setSelectedFilter: (state, payload) => {
    state.selectedFilter = payload;
  },
  setSelectedPreFilters: (state, payload) => {
    state.selectedPreFilters = payload;
  },
  setStoreTagPopUp: (state, payload) => {
    state.productPopUp = payload;
  },

  updateSort: (state, payload) => {
    state.sort = payload;
  },
  updatePagination: (state, payload) => {
    state.pagination = payload;
  },
  updateInitialFilter: (state, payload) => {
    state.initialFilter = payload;
  },
  updateFilterButtons: (state, payload) => {
    state.filterButtons = payload;
  },
};

const getters = {
  storeTags: (state) => state.storeTags,
  storeTag: (state) => state.storeTag,
  loadingStatus: (state) => state.loadingStatus,
  selectedFilter: (state) => state.selectedFilter,
  storeTagPopUp: (state) => state.storeTagPopUp,
  selectedPreFilters: (state) => state.selectedPreFilters,
  sort: (state) => state.sort,
  pagination: (state) => state.pagination,
  initialFilter: (state) => state.initialFilter,
  filterButtons: (state) => state.filterButtons,
};

const actions = {
  saveStoreTag: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "saveStoreTag", status: true });
    HttpService.post(
      Apis.backendBaseUrl + Apis.saveStoreTag,
      payload.storeTag,
      function (response, error) {
        commit("setLoadingStatus", { api: "saveStoreTag", status: false });
        if (response) {
          commit(
            "setMessage",
            { text: "Saved", type: "success" },
            { root: true }
          );
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          console.log(error);
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
        }
      }
    );
  },
  deleteStoreTag: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "deleteStoreTag", status: true });
    HttpService.post(
      Apis.backendBaseUrl + Apis.deleteStoreTag,
      payload.storeTag,
      function (response, error) {
        commit("setLoadingStatus", { api: "deleteStoreTag", status: false });
        if (response) {
          commit(
            "setMessage",
            { text: "Deleted", type: "success" },
            { root: true }
          );
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          console.log(error);
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
        }
      }
    );
  },
  getStoreTags: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit("setLoadingStatus", { api: "getStoreTags", status: true });
      let url = Apis.backendBaseUrl + Apis.getStoreTags + "?";

      if (payload?.filterCriteria && payload?.filterValue) {
        url +=
          `&filterCriteria=${payload.filterCriteria}` +
          `&filterValue=${payload.filterValue}`;
      }

      HttpService.get(url, function (response, error) {
        commit("setLoadingStatus", { api: "getStoreTags", status: false });
        var storeTags = {};

        if (response) {
          storeTags = response.data.body;
          resolve(storeTags);
          commit("setStoreTags", storeTags);
          return;
        }

        reject(error);
      });
    });
  },
  getStoreTagById: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "getStoreTagById", status: true });
    HttpService.get(
      Apis.backendBaseUrl + Apis.getStoreTagById + "?id=" + payload._id,
      function (response, error) {
        commit("setLoadingStatus", { api: "getStoreTagById", status: false });
        if (response) {
          commit("setStoreTag", response.data.body);
          if (payload.positiveCallback) {
            payload.positiveCallback(response.data.body);
          }
        } else {
          commit(
            "setMessage",
            { text: error.message, type: "error" },
            { root: true }
          );
          console.log(error);
        }
      }
    );
  },
  getAdjacent: ({ commit, state }, payload) => {
    commit("setLoadingStatus", { api: "getAdjacentStoreTag", status: true });
    const mode = payload.mode ? payload.mode : "next";
    var url =
      Apis.backendBaseUrl + "storeTag/" + Apis.getAdjacent + "?mode=" + mode;
    if (payload.createdAt) url = url + "&date=" + payload.createdAt;
    HttpService.get(url, function (response, error) {
      commit("setLoadingStatus", { api: "getAdjacentStoreTag", status: false });
      if (response) {
        if (payload && payload.positiveCallback) {
          payload.positiveCallback(response.data.body);
        }
      }
    });
  },
  setSelectedFilter: ({ commit, state }, payload) => {
    commit("setSelectedFilter", payload);
  },
  setStoreTagPopUp: ({ commit, state }, payload) => {
    commit("setStoreTagPopUp", payload);
  },
  setSelectedPreFilters: ({ commit, state }, payload) => {
    commit("setSelectedPreFilters", payload);
  },
  updateSort: ({ commit, state }, payload) => {
    commit("updateSort", payload)
  },
  updatePagination: ({ commit, state }, payload) => {
    commit("updatePagination", payload)
  },
  updateInitialFilter: ({ commit, state }, payload) => {
    commit("updateInitialFilter", payload)
  },
  updateFilterButtons: ({ commit, state }, payload) => {
    commit("updateFilterButtons", payload)
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};